import clsx from "clsx";
import { useState } from "react";

type Props = {
    experience?: any;
    conversation?: any;
}

export const MessagesExperienceInfo = ({ experience, conversation }: Props) => {
    const [open, setOpen] = useState(true);

    const bookingCode = experience?.bookingCode || experience?.booking_code || "N/A";
    const isHost = conversation?.isHost ?? conversation?.is_host;
    const hostName = isHost ? "You" : (experience?.host?.name || "N/A");
    const location = experience?.location || "N/A";
    const slots = experience?.slots || "Guest min. 0 and max. 0";
    const duration = experience?.duration || "N/A";

    const formattedDate = experience?.date ? new Date(experience.date).toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }) : "N/A";

    return (
        <div className={clsx("messages-info-card", { "collapsed": !open })}>
            <div className="d-flex flex-row justify-content-between w-100" style={{ cursor: 'pointer' }} onClick={() => setOpen(prev => !prev)}>
                <span className="title">experience info</span>
                <div className="collapse-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M12.5194 9.70701C12.4759 9.75059 12.4242 9.78517 12.3673 9.80876C12.3104 9.83235 12.2494 9.84449 12.1878 9.84449C12.1262 9.84449 12.0652 9.83235 12.0083 9.80876C11.9514 9.78517 11.8997 9.75059 11.8561 9.70701L7.50026 5.35056L3.1444 9.70701C3.05644 9.79497 2.93715 9.84438 2.81276 9.84438C2.68837 9.84438 2.56908 9.79497 2.48112 9.70701C2.39316 9.61905 2.34375 9.49976 2.34375 9.37537C2.34375 9.25098 2.39316 9.13168 2.48112 9.04373L7.16862 4.35623C7.21215 4.31265 7.26385 4.27807 7.32076 4.25448C7.37766 4.23089 7.43866 4.21875 7.50026 4.21875C7.56186 4.21875 7.62286 4.23089 7.67976 4.25448C7.73667 4.27807 7.78837 4.31265 7.8319 4.35623L12.5194 9.04373C12.563 9.08726 12.5976 9.13896 12.6211 9.19587C12.6447 9.25277 12.6569 9.31377 12.6569 9.37537C12.6569 9.43697 12.6447 9.49797 12.6211 9.55487C12.5976 9.61178 12.563 9.66348 12.5194 9.70701Z" fill="#151515"/>
                    </svg>
                </div>
            </div>
            {open && (
                <div className="d-flex flex-column w-100 align-items-start" style={{ gap: '10px' }}>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Booking Confirmation Number</span>
                        <span className="text-bold">{bookingCode}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Assistant</span>
                        <span className="text-bold">{hostName}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Location</span>
                        <span className="text-body-2">{location}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Date</span>
                        <span className="text-body-2">{formattedDate}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Available Slot</span>
                        <span className="text-body-2">{slots}</span>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Duration</span>
                        <span className="text-body-2">{duration}</span>
                    </div>
                </div>
            )}
        </div>
    )
}